<span
  *ngIf="status && status !== demurrageDetentionStatus.NotAvailable; else notAvailableTpl"
  class="demurrage-detention-status demurrage-detention-status_{{ status | kebabCase }}"
  [style.width.px]="size"
  [style.height.px]="size"
></span>
<ng-template #notAvailableTpl>
  {{ notAvailable }}
</ng-template>
